<script>
  import * as L from "leaflet";
  import { Icon, Marker } from "leaflet";
  import { createEventDispatcher } from "svelte";
  import icon from "leaflet/dist/images/marker-icon.png";
  import iconShadow from "leaflet/dist/images/marker-shadow.png";
  import * as esriLeaflet from "esri-leaflet";
  import { vectorBasemapLayer } from "esri-leaflet-vector";

  import "leaflet/dist/leaflet.css";

  const dispatch = createEventDispatcher();

  // props with default values in case none are passed in by a parent
  export let center = [0, 0];
  export let zoom = 2;

  const createMap = (domNode) => {
    let DefaultIcon = new Icon({
      iconUrl: icon,
      shadowUrl: iconShadow,
      iconAnchor: [12, 41],
      popupAnchor: [0, -41],
    });
    Marker.prototype.options.icon = DefaultIcon;

    const leafletMap = L.map(domNode);
    const layerGroup = L.layerGroup().addTo(leafletMap);
    leafletMap.setView([center[1], center[0]], zoom);

    vectorBasemapLayer("ArcGIS:Streets", {
      apiKey: "ARCGIS_API_KEY",
    }).addTo(leafletMap);

    // Wire up events:
    // leafletMap.on("moveend", (evt) => {
    //   dispatch("moveend", {
    //     latlng: leafletMap.getCenter(),
    //   });

    //   layerGroup.clearLayers();
    //   L.marker(leafletMap.getCenter()).addTo(layerGroup);
    // });

    leafletMap.on("click", (evt) => {
      dispatch("click", {
        latlng: evt.latlng,
      });

      layerGroup.clearLayers();
      L.marker(evt.latlng).addTo(layerGroup);
    });
  }

  // https://github.com/gavinr/esri-leaflet-react-demo/blob/e2c0199d976ed94a720bbd51292360996dee2e77/src/Map.js#L19
  const map = (domNode) => {
    // workaround for https://github.com/sveltejs/svelte/issues/5988
    if(domNode.clientHeight > 0) {
      createMap(domNode);
    } else {
      setTimeout(() => {
        createMap(domNode);
      }, 500);
    }
  };
</script>

<div class="leafletMapWrapper">
  <div class="map" use:map />
</div>
